import {
    validateAttendanceStatuses,
    validateContract,
    validateDate,
    validateService,
    validateServiceId,
    validateTeamIds
} from './validationFunctions';

export const validate = (type, selects) => {
    let newErrors = {};

    if (type === 'attendanceOutcomes') {
        newErrors = validateContract(selects.contract, newErrors);
        newErrors = validateService(selects.service, newErrors);
        newErrors = validateAttendanceStatuses(selects.attendanceStatuses, newErrors);
        newErrors = validateDate(selects.date, newErrors);
    }

    if (type === 'ctwReferral') {
        newErrors = validateContract(selects.contract, newErrors);
        newErrors = validateService(selects.service, newErrors);
    }

    if (type === 'financialRequest') {
        newErrors = validateContract(selects.contract, newErrors);
        newErrors = validateServiceId(selects.serviceId, newErrors);
        newErrors = validateTeamIds(selects.teamIds, newErrors);
        newErrors = validateDate(selects.date, newErrors);
    }

    if (type === 'referralsCreated') {
        newErrors = validateContract(selects.contract, newErrors);
    }

    return newErrors;
};
